"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Axis;
(function (Axis) {
    Axis["X"] = "X";
    Axis["Y"] = "Y";
    Axis["BOTH"] = "BOTH";
    Axis["NONE"] = "NONE";
})(Axis || (Axis = {}));
exports.default = Axis;
var AxisStore = {
    X: Axis.X,
    Y: Axis.Y,
    BOTH: Axis.BOTH,
    NONE: Axis.NONE
};
exports.AxisStore = AxisStore;
//# sourceMappingURL=Axis.js.map